const buildImageProps = (image, placeholderImage) => {
    var _a, _b;
    if (placeholderImage) {
        return { placeholderImageSrc: placeholderImage };
    }
    if (image) {
        const processedImageUrl = image.isProcessed && ((_b = (_a = image.processed) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.url);
        return processedImageUrl
            ? {
                placeholderImageSrc: processedImageUrl
            }
            : {
                uncroppedImage: image
            };
    }
    return {};
};
export default buildImageProps;
//# sourceMappingURL=buildImageProps.js.map